import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { setToken } from '../../../store/auth';
import { loadAuth } from '../../../api/auth';
import { useAppDispatch, useQuery } from '../../../hooks';
export const Authenticated = ({ children }) => {
    const { param: fromUrl, delParam } = useQuery('fromUrl');
    const dispatch = useAppDispatch();
    const token = loadAuth(null);
    const nav = useNavigate();
    const location = useLocation();
    const url = useMemo(() => `${location.pathname}${location.search}` || '/', [location]);
    // console.log('Authenticated location', location)
    useEffect(() => {
        console.log(token);
        if (!token && url.includes('match-final')) {
            nav(url || '/');
        }
        else if (!token) {
            delParam('fromUrl');
            nav(`/login`);
        }
        else {
            dispatch(setToken(token));
            nav(url || '/');
            // nav('/events')
        }
    }, [token]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
};
